import { NgModule } from "@angular/core";

// Import Module
import { DesignSystemRoutingModule } from "./design-system-routing.module";

// Import Component
import { DesignSystemComponent } from "./design-system.component";
import { ComponentComponent } from "./component/component.component";

@NgModule({
    imports: [
        DesignSystemRoutingModule
    ],
    declarations: [
        DesignSystemComponent
    ]
})

export class DesignSystemModule { }
